import { SpeakerItem } from "./SpeakerItem";

export default SpeakerItem;
